import React, { useEffect } from 'react';
import { X, Scale } from 'lucide-react';

interface MentionsLegalesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MentionsLegalesModal: React.FC<MentionsLegalesModalProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', handleKeyDown); document.body.style.overflow = previousOverflow; };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-appines-black/60 backdrop-blur-sm" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="mentions-legales-title">
      <div className="relative w-full max-w-3xl max-h-[90vh] flex flex-col bg-appines-white rounded-2xl shadow-2xl overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-5 border-b border-[rgba(1,42,54,0.12)] bg-appines-white">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-appines-glass/25">
              <Scale className="w-5 h-5 text-appines-emerald" />
            </div>
            <h2 id="mentions-legales-title" className="text-xl font-semibold text-appines-petrol">Mentions légales</h2>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg text-appines-petrol/45 hover:text-appines-petrol hover:bg-[rgba(1,42,54,0.06)] transition-colors" aria-label="Fermer les mentions légales">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-6 space-y-6 text-appines-petrol/80">
          <section>
            <h3 className="text-lg font-semibold text-appines-petrol mb-2">Editeur du site</h3>
            <p className="text-base leading-relaxed">Le présent site est édité par la société App'Ines, Société par Actions Simplifiée, au capital de 29 830 €, inscrite au registre du commerce et des sociétés de Brive-la-Gaillarde (19) sous le numéro 838 878 601 00015.</p>
            <ul className="mt-2 space-y-1 text-base leading-relaxed">
              <li><strong>Code APE :</strong> 6201Z</li>
              <li><strong>Siège social :</strong> Le Bourg, 19200 Saint-Pardoux-le-Neuf</li>
            </ul>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-appines-petrol mb-2">Directeur de la publication</h3>
            <p className="text-base leading-relaxed">Monsieur Adrien Bourzat, en sa qualité de Président.</p>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-appines-petrol mb-2">Contact</h3>
            <p className="text-base leading-relaxed">Adresse e-mail : <a href="mailto:contact@appines.fr" className="text-appines-emerald hover:text-[#22b886] font-medium transition-colors">contact@appines.fr</a></p>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-appines-petrol mb-2">Hébergement</h3>
            <p className="text-base leading-relaxed">Le site est hébergé par Netlify, Inc., 44 Montgomery Street, Suite 300, San Francisco, California 94104, États-Unis.</p>
            <p className="mt-2 text-base leading-relaxed">Les données sont hébergées par Supabase, Inc. (Amazon Web Services – région EU).</p>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-appines-petrol mb-2">Propriété intellectuelle</h3>
            <p className="text-base leading-relaxed">L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes, etc.) est la propriété exclusive de la société App'Ines, à l'exception des marques, logos ou contenus appartenant à d'autres sociétés partenaires ou auteurs.</p>
            <p className="mt-2 text-base leading-relaxed">Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces différents éléments est strictement interdite sans l'accord exprès par écrit d'App'Ines.</p>
          </section>
        </div>

        <div className="px-6 py-4 border-t border-[rgba(1,42,54,0.12)] bg-[rgba(1,42,54,0.04)] flex justify-end">
          <button onClick={onClose} className="px-5 py-2 rounded-lg bg-appines-emerald text-appines-petrol font-medium hover:bg-[#22b886] transition-colors">Fermer</button>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegalesModal;
